import { Box, TextField } from '@mui/material';
import { Check, Close } from '@mui/icons-material';

// The sales text's points, also enforced by the API.
const MaxSalesPoints = 8;
const MaxSalesPointLength = 120;

export const salesPoints = (text?: string | null) =>
  (text ?? '')
    .split('\n')
    .map((x) => x.trim())
    .filter(Boolean);

const NotIncluded = /^[-–−]\s*/;
const notIncluded = (point: string) => (NotIncluded.test(point) ? point.replace(NotIncluded, '') : null);

export function salesTextError(text: string): string | null {
  const points = salesPoints(text);
  if (points.length > MaxSalesPoints) return `Høyst ${MaxSalesPoints} punkter.`;
  if (points.some((x) => x.length > MaxSalesPointLength)) return `Hvert punkt kan være høyst ${MaxSalesPointLength} tegn.`;
  return null;
}

interface FieldProps {
  value: string;
  onChange(value: string): void;
  about: string;
}

export function SalesTextField({ value, onChange, about }: FieldProps) {
  const error = salesTextError(value);
  return (
    <TextField
      label="Salgstekst"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      multiline
      minRows={4}
      helperText={
        error ??
        `${about} Ett punkt per linje, listet med hake; start en linje med - for noe som ikke er med. ${salesPoints(value).length}/${MaxSalesPoints} punkter`
      }
      error={error !== null}
      fullWidth
    />
  );
}

export function SalesPointsList({ text }: { text: string }) {
  return (
    <Box component="ul" sx={{ m: 0, p: 0, listStyle: 'none' }}>
      {salesPoints(text).map((point, index) => {
        const excluded = notIncluded(point);
        return (
          // By position: two points may read the same.
          <Box component="li" key={index} sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            {excluded !== null ? <Close fontSize="inherit" color="error" /> : <Check fontSize="inherit" color="success" />}
            {excluded ?? point}
          </Box>
        );
      })}
    </Box>
  );
}
